import React from 'react';
import { styled, Typography } from '@mui/material';
import { moneyFormat } from 'helpers/moneyFormat';

const Section = styled('section')(({ theme }) => ({
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 2),
}));

const Line = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) 130px 130px',
  columnGap: theme.spacing(2),
  alignItems: 'center',
  padding: theme.spacing(1, 0),
  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '&.body.clickable': {
    cursor: 'pointer',
  },
  '&.body.clickable:hover': {
    backgroundColor: theme.palette.grey[50],
  },
  '& .number': {
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    '& .min': { display: 'none' },
  },
}));

export interface RecordPriceItem {
  key: string | number;
  name: string;
  min: number;
  max: number;
}

interface RecordPriceListProps {
  title: string;
  items: RecordPriceItem[];
  empty: string;
  note: string;
  onSelect?(item: RecordPriceItem): void;
}

// Procedimentos com a faixa de preço (mínimo e máximo), somente leitura, na ficha do médico e do hospital.
const RecordPriceList: React.FC<RecordPriceListProps> = ({ title, items, empty, note, onSelect }) => (
  <Section>
    <Typography variant="subtitle2" fontWeight={700} color="primary" sx={{ mb: 0.5 }}>
      {title}
    </Typography>

    {items.length === 0 ? (
      <Typography variant="body2" color="textSecondary" sx={{ py: 2 }}>
        {empty}
      </Typography>
    ) : (
      <>
        <Line>
          <Typography variant="caption" color="textSecondary">
            Procedimento
          </Typography>
          <Typography className="number min" variant="caption" color="textSecondary">
            Mínimo
          </Typography>
          <Typography className="number" variant="caption" color="textSecondary">
            Máximo
          </Typography>
        </Line>
        {items.map(item => (
          <Line
            key={item.key}
            className={onSelect ? 'body clickable' : 'body'}
            onClick={onSelect ? () => onSelect(item) : undefined}
          >
            <Typography variant="body2" fontWeight={700}>
              {item.name || '-'}
            </Typography>
            <Typography className="number min" variant="body2">
              {moneyFormat(item.min)}
            </Typography>
            <Typography className="number" variant="body2">
              {moneyFormat(item.max)}
            </Typography>
          </Line>
        ))}
        <Typography variant="caption" color="textSecondary" display="block" sx={{ mt: 1 }}>
          {note}
        </Typography>
      </>
    )}
  </Section>
);

export default RecordPriceList;
